module.exports = __webpack_public_path__ + "Step2_Header_new.573f451f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/desktop/headers/Step2_Header_new.png
// module id = TAPr
// module chunks = 0